import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { OrganizationsState } from '../organizations/OrganizationsState';
import { useSubscription } from '@meraki-internal/state';
import { NavigationItemList } from './NavigationItemList';
import { AddCareMapButton } from '../caremap/AddCareMapButton';
import { AppPrincipal, isAnonymousViewer } from '../auth/AppPrincipal';
import { Divider } from '../components/Divider';

interface NewUINavigationListProps {
    closeMenuHandler?: () => void;
}

export const NewUINavigationList: React.FC<NewUINavigationListProps> = ({ closeMenuHandler  }) => {
    const isAnonymous = isAnonymousViewer(useInstance(AppPrincipal));

    const careMapState = useInstance(CareMapState);
    useSubscription(() => careMapState);

    const orgState = useInstance(OrganizationsState);
    useSubscription(() => orgState);

    // don't show nav, that would direct user to create a personal caremap
    if (orgState.isOrgTeamMember() && !careMapState.getMostRecentCaremap()){
        return null;
    }

    // if there's a careMap.essentialMapComplete === false (ie appt recording), don't show me
    const showAddButton = !orgState.isOrgTeamMember() && !isAnonymous && !careMapState.getIncompleteCareMap();

    return (
        <NavigationItemList>
            {showAddButton && (
                <>
                    <div style={{margin: 24}}>
                        <AddCareMapButton closeMenu={() => {
                            if (closeMenuHandler){
                                closeMenuHandler();
                            }
                        }} />
                    </div>
                    <Divider />
                </>
            )}
        </NavigationItemList>
    );
};
